type Props = {
  kota: string
  jenjang: string
  mitra: string
  bulanAwal: string
  bulanAkhir: string
  tahunAwal: string
  tahunAkhir: string
}

const ChartActiveFilterHeader = ({
  kota,
  jenjang,
  mitra,
  bulanAwal,
  bulanAkhir,
  tahunAwal,
  tahunAkhir,
}: Props) => (
  <div>
    <h2 className='text-dark fw-bold mb-3 text-center fs-4'>
      Di {kota || 'Semua Kota'}, {jenjang || 'Semua Jenjang'}, {mitra || 'Semua Mitra'}
    </h2>
    <h2 className='text-dark fw-bold mb-5 text-center fs-4'>
      Periode {bulanAwal} {tahunAwal} - {bulanAkhir} {tahunAkhir}
    </h2>
  </div>
)

export {ChartActiveFilterHeader}
